import { useQuery } from '@tanstack/react-query';

import { fetcher, endpoints } from 'src/utils/axios';

import { queryKeys } from 'src/react-query/constants';

import { IPortalMembership } from 'src/types/portal';

// ----------------------------------------------------------------------

// The success body is the Ardalis.Result envelope; unwrap `value` when present.
function unwrap(raw: any): IPortalMembership[] {
  const value =
    raw && typeof raw === 'object' && 'value' in raw && 'isSuccess' in raw ? raw.value : raw;
  return Array.isArray(value) ? (value as IPortalMembership[]) : [];
}

// The Locker portal agencies the authenticated user belongs to (resolved server-side from the
// membership token claim, with a single-agency fallback). Drives the bare /portal redirector.
export function useMyMemberships() {
  const { data, isLoading, isError } = useQuery({
    queryKey: [queryKeys.portalMemberships],
    queryFn: async () => unwrap(await fetcher(endpoints.portal.myMemberships)),
    retry: false,
    refetchOnWindowFocus: false,
  });

  return { memberships: data ?? [], isLoading, isError };
}
